/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
  items?: number
  data?: any
  name?: string
}

const ListsWidget4: React.FC<Props> = ({ className, name = 'Top 5 Customer', items = 6, data }) => {
  var newData = Array.isArray(data)
    ? data
    : data &&
    Object.entries(data).map(([name, value]) => ({
      name,
      value,
    }))
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bold mb-2 text-dark'>{name}</span>
          {/* <span className='text-dark mt-1 fw-semibold fs-7'>Latest tech trends</span> */}
        </h3>
        {/*  <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTIcon iconName='category' className='fs-2' />
          </button>
          <Dropdown1 />
        </div> */}
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-2'>
        {newData.map((eachData, eachInd) => (
          <div key={eachInd + 1 + ''} className='d-flex align-items-sm-center mb-7'>
            <div className='symbol symbol-50px me-5'>
              <span className='symbol-label'>
                <img
                  src={toAbsoluteUrl('/media/svg/brand-logos/cust.png')}
                  className='h-50 align-self-center'
                  alt=''
                />
              </span>
            </div>
            <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
              <div className='flex-grow-1 me-2'>
                <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                  {eachData.name}
                </a>
                {/* <span className='text-dark fw-semibold d-block fs-7'>Mark, Rowling, Esther</span> */}
              </div>
              {/* <span className='badge badge-light fw-bold my-2'>
                {eachData.value || eachData.totalValue || ''}
              </span> */}
              <span className='badge badge-light fw-bold my-2 text-black'>
                {/* {(eachData.value || eachData.totalValue || 0).toFixed(2)} */}
                {eachData.value || eachData.totalValue || 0}
              </span>
            </div>
          </div>
        ))}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { ListsWidget4 }
